<template>
	<div class="person-fee-wrapper single-page-wrap">
		<div class="top-title">
			<p>已使用: {{ form.usedCouponSum }} ┃ 未使用: {{ form.unuseCouponSum }} ┃ 总计: {{ form.couponSum }}</p>
			<p @click="handleBind">绑定停车券</p>
		</div>
		<div class="weui-navbar">
			<div v-for="(item, index) of navBarList" :key="item.id" class="weui-navbar__item"
				:class="navItemIdx === index ? 'weui-bar__item_on' : ''" @click="handleNavBar(item.id, index)">{{ item.name }}
			</div>
		</div>

		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
			<div class="fee-list-wrapper" v-if="userCouponList.length > 0">
				<div class="fee-wrap" v-for="item of userCouponList" :key="item.couponId">
					<div class="fee-type"  :style="{
						backgroundColor: item.color,
						
					}">
						<p>{{ item.coupontypeName }}</p>
						<p style="padding-top: 5px">{{ item.typeName }}</p>
					</div>
					<div class="fee-content">
						<p>{{ item.parkinglotName }}</p>
						<p v-show="item.beginLimitTime">开始：{{ item.beginLimitTime }}</p>
						<p v-show="item.endLimitTime">截止：{{ item.endLimitTime }}</p>
					</div>
					<div class="weui-btn-wrapper" v-if="item.allowGive == 1 && !isUsed">
						<button class="weui-btn weui-btn_mini weui-btn_default"
							@click="handleGive(item.couponId)">赠送</button>
						<!-- <button class="weui-btn weui-btn_mini weui-btn_default" @click="handleQrCode(item.couponId)">二维码</button> -->
					</div>
				</div>
			</div>
			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>

		<div class="js_dialog" v-show="isClickGive">
			<div class="weui-mask"></div>
			<div class="weui-dialog" style="top: 30%">
				<div ref="telForm" class="weui-form-area">
					<div class="weui-cells weui-cells_form">
						<div class="weui-cell weui-cell_vcode">
							<div class="weui-cell__hd">
								<label class="weui-label">手机号码</label>
							</div>
							<div class="weui-cell__bd">
								<input class="weui-input" type="tel" pattern="[0-9]{11}" v-model="givePhone" @blur="blur"
									required notMatchTips="对方绑定的手机号" emptyTips="对方绑定的手机号" placeholder="对方绑定的手机号">
							</div>
						</div>
					</div>
				</div>
				<div class="weui-dialog__ft">
					<a class="weui-dialog__btn weui-dialog__btn_default" @click="cancle">取消</a>
					<a class="weui-dialog__btn weui-dialog__btn_primary" @click="confirmToGive">立即赠送</a>
				</div>
			</div>
		</div>
		<div v-show="isClickQrCode">
			<!--BEGIN dialog1-->
			<div class="js_dialog">
				<div class="weui-mask" @click="close"></div>
				<div id="js_half_screen_dialog" class="weui-half-screen-dialog">
					<div class="weui-half-screen-dialog__hd">
						<div class="weui-half-screen-dialog__hd__side" @click="close">
							<button class="weui-icon-btn">关闭<i class="weui-icon-close-thin"></i></button>
						</div>
						<div class="weui-half-screen-dialog__hd__main">
							<strong class="weui-half-screen-dialog__title">标题</strong>
						</div>
					</div>
					<div class="weui-half-screen-dialog__bd">
						<vue-qr :text="url" :margin="0" :size="250"></vue-qr>
						<article class="weui-article">
							<section>
								<p>请出示二维码进行抵扣，本页面会在{{ second }}后查询是否被使用</p>
								<br>
								<p v-if="time > 0">第{{ time }}次查询，停车券未被使用</p>
							</section>
						</article>
					</div>
				</div>
			</div>
			<!--END dialog1-->
		</div>
	</div>
</template>

<script>
import { getUserCouponList, userGiveCoupon } from "@/api/coupon/personalParkingFee";
import vueQr from 'vue-qr';
import { mapGetters } from 'vuex'
import scan from '@/api/coupon/scan'
import base from "@/api/base";
import { LocationManager } from "@/utils/LocationManagerUrl"
export default {
	name: "personalParkingFee",
	components: {
		vueQr
	},
	computed: {
		...mapGetters(['userOpenid'])
	},
	data() {
		return {
			url: '',
			baseHttps: base.https,
			baseHttp: base.http,
			baseUrl: base.url + "/",
			time: 0,
			isUsed: false,
			second: 5,
			form: {},
			couponId: undefined,
			givePhone: undefined,
			isClickGive: false,
			isClickQrCode: false,
			userCouponList: [],
			scrollOptions: {
				click: true,
				bounce: false
			},
			navItemIdx: 0,
			status: 1,
			navBarList: [
				{ id: 1, name: '未使用' },
				{ id: 2, name: '已使用' },
			],
			couponTypeOptions: {
				0: '可以抵用一次,countBg',
				1: '可抵,timeBg',
				2: '可抵,moneyBg',
				3: '免费抵用,monthBg',
				4: '抵扣部分金额,limitBg',
				5: "其他,visitBg",
				12: "时长包天券,time"
			}
		}
	},
	mounted() {
		this.url = scan.link + '?taskId=' + this.$route.params.id +'&actualSaleMoney=' + this.$route.params.actualSaleMoney +'&isGZH=' + true;
		this.getList()
	},
	methods: {
		blur() {
			window.scrollTo(0, 0)
		},
		getList() {
			getUserCouponList({ openid: localStorage.getItem('userOpenId')||this.userOpenid , status: this.status }).then(res => {
				if (res.code === 200) {
					this.form = res.data;
					console.log(res.data.userCouponVOList, ' res.data.userCouponVOList');
					let userCouponList = res.data.userCouponVOList;
					this.userCouponList = userCouponList;
					this.$nextTick(() => {
						this.$refs.scroll.refresh()
					})
				}
			})
		},
		handleNavBar(typeId, idx) {
			typeId === 2 ? this.isUsed = true : this.isUsed = false;
			this.status = typeId;
			this.navItemIdx = idx;
			this.$refs.scroll.scrollTo(0, 0, 200);
			this.getList()
		},
		handleGive(couponId) {
			this.couponId = couponId;
			this.givePhone = undefined;
			this.isClickGive = true;
		},
		handleQrCode() {
			this.isClickQrCode = true;
			this.timer()
		},
		timer() {
			let promise = new Promise(resolve => {
				setInterval(
					() => {
						if (this.second <= 1) {
							this.second = 5;
							// resolve(this.setTimer)
							this.time++;
						} else {
							this.second -= 1;
						}
					}, 1000)
			});
			promise.then((setTimer) => {
				clearInterval(setTimer)
			})
		},
		confirmToGive() {
			let telForm = this.$refs.telForm;
			this.$weui.form.validate(telForm, error => {
				if (!error) {
					let form = {
						couponid: this.couponId,
						giverOpenid: localStorage.getItem('userOpenId')||this.userOpenid ,
						receiverPhone: this.givePhone
					};
					userGiveCoupon(form).then(res => {
						if (res.code == 200) {
							this.$weui.alert('赠送成功', { title: '成功' });
							this.isClickGive = false;
							this.getList();
						}
					})
				}
			});
		},
		cancle() {
			this.isClickGive = false;
		},
		close() {
			this.isClickQrCode = false
		},
		handleBind() {
			LocationManager("/weChat/personalBind")

		}
	}
}
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.person-fee-wrapper{
		.weui-navbar{
			border-top 1px solid #e6e6e6
			>>> .weui-navbar__item{
				font-size 16px
				color #6d6d6d
			}
			>>> .weui-navbar__item.weui-bar__item_on{
				font-size 20px
				font-weight 500
				color $color-green
			}
		}
		.top-title{
			padding 10px 15px
			display flex
			justify-content space-between
			align-items center
			font-size $article-p
			color $article-p-color
			p:last-child{
				font-size 15px
				color #05C160
			}
		}
		.cube-scroll{
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 80%
			overflow hidden
			/*background: #ffffff;*/
			margin-bottom 50px
			.no-data-wrap{
				padding-top 25%
				display flex
				justify-content center
				align-items center
				.weui-article{
					color $no-data-font-color
					h1{
						font-size $no-data-font-size
					}
				}
			}
		}
		.fee-list-wrapper{
			.fee-wrap{
				box-shadow 0 0 4px #ccc
				padding-right 10px
				margin 5px 15px 15px 15px
				display flex
				align-items center
				.fee-type{
					width 30%
					height 50px
					font-size $article-p
					color #fff
					text-align center
					display flex
					flex-direction column
					align-items center
					justify-content space-between
					padding 20px 0
					background: radial-gradient(circle at 50% 50%, #fff 0, #fff 50%, transparent 0);
					background-repeat: repeat-y;
					background-size: 10px 10px;
					background-position: 100% + 5px calc(-100% + 5px), calc(-100% - 5px) 5px;
					p:first-child{
						font-size 16px
						padding 0 4px
					}
				}
				.timeBg {
					background-color: #05C160;
				}
				.countBg{
					background-color: #0FAEFF;
				}
				.time{
					background-color: #D9D9F3 ;
				}
				.moneyBg{
					background-color: #FF6600;
				}
				.monthBg{
					background-color: #FFBA00;
				}
				.limitBg{
					background-color: #0355DB;
				}
				.visitBg{
					background-color: #576b95
				}
				.fee-content{
					flex 1
					font-size $article-p
					color $article-p-color
					padding-left 10px
					line-height 14px
					p:first-child{
						font-size 16px
						color black
						line-height 26px
					}
				}
				.weui-btn-wrapper{
					display flex
					flex-direction column
					.weui-btn_default{
						font-size 12px
						color #0FAEFF
					}
					.weui-btn_default:last-child{
						margin-top 8px
					}
				}

			}
		}

		.weui-form-area{
			padding 30px 10px
			.weui-cells_form{
				padding 10px 0
			}
			.weui-cells:before{
				border none
			}
			.weui-cells:after{
				border none
			}
		}
		.weui-dialog__btn{
			font-size 16px
		}
		.weui-half-screen-dialog__bd{
			display flex
			flex-direction column
			align-items center
		}
	}
</style>
